module.exports = __webpack_public_path__ + "static/media/23_Clinical_Guidelines_National.2611d9e9.pdf";